import {
  PERSON_RECEIVE,
  PERSON_ERROR,
  PERSON_CHANGE_MODE,
  ADDRESS_RECEIVE,
  ADDRESS_ERROR,
  ADDRESS_CHANGE_MODE,
  ORDER_RECEIVE,
  ORDER_ERROR,
  ORDER_CHANGE_MODE,
  ORDER_CHANGE_CURRENTPAGE,
  ORDER_SET_ORDER,
  RETURN_ORDER_RESPONSE_RECEIVE,
  SET_ADDRESS_ERRORS,
  SET_PERSON_ERRORS,
  SET_ADDRESS_SUCCESS_MESSAGE,
  SET_PERSONS_SUCCESS_MESSAGE,
} from '../constants';
import { person as personReducer } from './Person.reducer';
import { address as addressReducer } from './Address.reducer';
import {
  DEFAULT_STATE as DEFAULT_ORDER_STATE,
  order as orderReducer,
  ORDER_STATE,
  RETURN_ORDER_STATE,
  DEFAULT_RETURN_ORDER_STATE,
  returnOrder as returnOrderReducer,
} from './Order.reducer';
import { AnyAction } from 'redux';

interface MyPageState {
  persons: any;
  addresses: any;
  orders: ORDER_STATE;
  returnOrder: RETURN_ORDER_STATE;
}

const DEFAULT_STATE: MyPageState = {
  persons: {},
  addresses: {},
  orders: DEFAULT_ORDER_STATE,
  returnOrder: DEFAULT_RETURN_ORDER_STATE,
};

export const myPage = (
  state = DEFAULT_STATE,
  action: AnyAction
): MyPageState => {
  const { type, payload } = action;
  switch (type) {
    case PERSON_RECEIVE:
    case PERSON_ERROR:
    case PERSON_CHANGE_MODE:
    case SET_PERSON_ERRORS:
    case SET_PERSONS_SUCCESS_MESSAGE:
      return {
        ...state,
        persons: personReducer(state.persons, action),
      };
    case ADDRESS_RECEIVE:
    case ADDRESS_ERROR:
    case ADDRESS_CHANGE_MODE:
    case SET_ADDRESS_ERRORS:
    case SET_ADDRESS_SUCCESS_MESSAGE:
      return {
        ...state,
        addresses: addressReducer(state.addresses, action),
      };
    case ORDER_RECEIVE:
    case ORDER_ERROR:
    case ORDER_CHANGE_MODE:
    case ORDER_CHANGE_CURRENTPAGE:
    case ORDER_SET_ORDER:
      return {
        ...state,
        orders: orderReducer(state.orders, action),
      };
    case RETURN_ORDER_RESPONSE_RECEIVE:
      return {
        ...state,
        returnOrder: returnOrderReducer(state.returnOrder, action),
      };
    default:
      return state;
  }
};
